export default "__VITE_ASSET__CGT4UXN2__"